import React, { useState } from "react"
import Combobox from "@shared/combobox"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const AddMeters = ({ meters, siteMeters }) => {
  if (!siteMeters) return null

  const [selectedMeters, setSelectedMeters] = useState(
    meters.map(m => ({
      id: m.id,
      meterId: m.meterId,
      name: m.name,
      conversionRate: m.conversionRate || "",
      _destroy: false
    }))
  )

  const availableMeters = siteMeters.filter(
    siteMeter =>
      !selectedMeters.some(
        selected => selected.meterId === siteMeter.id && !selected._destroy
      )
  )

  const addMeter = e => {
    e.preventDefault()
    setSelectedMeters([
      ...selectedMeters,
      { id: null, meterId: null, name: "", conversionRate: "", _destroy: false }
    ])
  }

  const removeMeter = (e, index) => {
    e.preventDefault()
    const updated = [...selectedMeters]
    const meterToRemove = updated[index]

    if (meterToRemove.id) {
      updated[index]._destroy = true
    } else {
      updated.splice(index, 1)
    }

    setSelectedMeters(updated)
  }

  const handleChange = (index, field, value) => {
    const updated = [...selectedMeters]

    if (field === "meterId") {
      updated[index].meterId = value
    } else {
      updated[index][field] = value
    }

    setSelectedMeters(updated)
  }

  return (
    <>
      <div className="cocoon-grid mb-2">
        <div className="cocoon-grid__header">
          <label>{I18n.t("meters_groups.meters")}</label>
        </div>
      </div>

      {selectedMeters.map((meter, index) => {
        const currentMeter = siteMeters.find(m => m.id === meter.meterId)
        const options = currentMeter
          ? [...availableMeters, currentMeter]
          : availableMeters

        return (
          <div
            key={index}
            className={`form-group d-flex align-items-center ${meter._destroy ? "d-none" : ""}`}
          >
            <Combobox
              fieldName={`meters_group[meters_group_meters_attributes][${index}][meter_id]`}
              prompt={I18n.t("meters_groups.select_meter")}
              options={options}
              onSelectElement={selected => handleChange(index, "meterId", selected.id)}
              value={meter.meterId || ""}
              required
            />

            <input
              type="number"
              name={`meters_group[meters_group_meters_attributes][${index}][conversion_rate]`}
              className="form-control mx-2 w-30"
              value={meter.conversionRate}
              placeholder={I18n.t("meters_groups.conversion_rate")}
              onChange={e => handleChange(index, "conversionRate", e.target.value)}
              required
            />

            <a href="#" onClick={e => removeMeter(e, index)}>
              <FontAwesomeIcon icon="minus-circle" />
            </a>

            <input
              type="hidden"
              name={`meters_group[meters_group_meters_attributes][${index}][id]`}
              value={meter.id || ""}
            />

            <input
              type="hidden"
              name={`meters_group[meters_group_meters_attributes][${index}][meter_id]`}
              value={meter.meterId || ""}
            />

            {meter._destroy && (
              <input
                type="hidden"
                name={`meters_group[meters_group_meters_attributes][${index}][_destroy]`}
                value="true"
              />
            )}
          </div>
        )
      })}

      {availableMeters.length > 0 && (
        <a className="small flex-end mt-2" href="#" onClick={addMeter}>
          <FontAwesomeIcon icon="plus-circle" className="mr-1" />
          {I18n.t("meters_groups.add_meter")}
        </a>
      )}
    </>
  )
}

export default AddMeters
